import React, { useState } from 'react';
import modis from '../../../assets/icons/modis.png';
import downArrowIcon from '../../../assets/icons/down-arrow.png';
import Tooltip from "@mui/material/Tooltip";
import FeatureLayerWidget from './FeatureLayerWidget';
import RasterWidget from './RasterWidget';

export default function SatelliteLayers(props) {
    const {
        map,
        satelliteLayers,
        setSatelliteLayers,
        selectedSatelliteLayer,
        setSelectedSatelliteLayer
    } = props;

    const [expanded, setExpanded] = useState(false);

    return (
       <div className='weather-widgets-feature-layer-widget-expandable'>
            <Tooltip
                title='Displays satellite-based 7-day fire activity and weather maps for wildfire monitoring.'
                arrow
                placement='left'
                
            >
                <div 
                    className={selectedSatelliteLayer ? 'weather-widgets-widget-active' : 'weather-widgets-widget'}
                    style={{  zIndex: 20 }}
                    onClick={() => {
                        setExpanded((prevState) => !prevState);
                    }}                    
                >
                    <div className={selectedSatelliteLayer ? 'weather-widgets-widget-active-title' : 'weather-widgets-widget-title'}> 
                        <img 
                            src={downArrowIcon} 
                            className='weather-widgets-widget-arrow'
                            style={{
                                transition: 'transform 0.5s ease',
                                transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
                            }}
                        />
                        Satellite Overlays
                    </div>
                    <div className='weather-widgets-widget-img-container'>
                        <img 
                            src={modis} 
                            className='weather-widgets-widget-img'
                            style={{ filter: 'invert(100%)' }}
                        />
                    </div>
                </div>
            </Tooltip>
            {expanded &&
            <div 
                className='weather-widgets-feature-layer-widget-expandable-expanded'
                style={{ zIndex: 19 }}
                >
                {satelliteLayers && satelliteLayers.map((layer) => {
                   return (
                      <RasterWidget layer={layer} map={map} selectedSatelliteLayer={selectedSatelliteLayer} setSelectedSatelliteLayer={setSelectedSatelliteLayer}/>
                   )
                })}
            </div>
            }
       </div>
    )
}
